// extracted by mini-css-extract-plugin
export default {"eventcal":"ManagerHeader_eventcal__I2u5B","active":"ManagerHeader_active__yFTw3","tabheader":"ManagerHeader_tabheader__jofK-"};